module.exports = __webpack_public_path__ + "img/exit_jobmule.207e121d.png";